export default __webpack_public_path__ + "static/media/css-layout.b6a87097.jpg";